
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { isAuthenticated, isSuperAdmin, logoutUser, getCurrentUser } from '@/utils/auth';
import { safeUserRole } from '@/utils/roleUtils';

export const useSuperAdminSettings = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('system');
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = getCurrentUser();
      const userRole = currentUser?.role || '';
      
      if (!isAuthenticated() || !isSuperAdmin(safeUserRole(userRole))) {
        navigate('/login');
        return;
      }
      
      setUser(currentUser);
      setIsLoading(false);
    };
    
    checkAuth();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await logoutUser();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const handleSaveSettings = (section: string) => {
    toast({
      title: "Settings Saved",
      description: `${section} settings have been updated successfully.`,
    });
  };

  return {
    isLoading,
    activeTab,
    setActiveTab,
    user,
    handleLogout,
    handleSaveSettings
  };
};
